export default "__VITE_ASSET__CURZQx_4__"